// TomSelect plugin "fx_checkbox_untabbable": list it right AFTER "checkbox_options".
// The checkboxes that plugin puts in each option are a picture of the option's state: the
// option row is the control (arrows + Enter / Space and clicks select it, aria-selected
// carries the state). Left in the tab order, Tab from the field moved focus onto the first
// checkbox inside the open list; the list closed on that blur and focus fell back to <body>,
// so for one Tab press nothing on the page was focused (2.4.3 / 2.4.7). Now Tab goes straight
// to the next control after the field.
import TomSelect from 'tom-select';

if (!(TomSelect.plugins && TomSelect.plugins.fx_checkbox_untabbable)) {
    TomSelect.define('fx_checkbox_untabbable', function () {
        const self = this;

        // runs after checkbox_options' own setupTemplates hook (plugins hook in list order),
        // so it wraps the option template that already holds the checkbox
        self.hook('after', 'setupTemplates', () => {
            const renderOption = self.settings.render.option;

            self.settings.render.option = function (data, escape) {
                const rendered = renderOption.call(self, data, escape);
                if (rendered instanceof HTMLElement) {
                    rendered.querySelectorAll('input.tomselect-checkbox').forEach((checkbox) => {
                        checkbox.tabIndex = -1;
                    });
                }

                return rendered;
            };
        });
    });
}
